// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestmentOptionsTypePropertyDto
 */
export interface IInvestmentOptionsTypePropertyDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof IInvestmentOptionsTypePropertyDto
     */
    investment_options_types?: Set<IInvestmentOptionsTypePropertyDtoInvestmentOptionsTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentOptionsTypePropertyDto
     */
    investment_options_type_state?: IInvestmentOptionsTypePropertyDtoInvestmentOptionsTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IInvestmentOptionsTypePropertyDtoInvestmentOptionsTypesEnum {
    MANAGED = 'MANAGED',
    SELF_DIRECTED = 'SELF_DIRECTED',
    BROKERAGE = 'BROKERAGE'
}
/**
* @export
* @enum {string}
*/
export enum IInvestmentOptionsTypePropertyDtoInvestmentOptionsTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IInvestmentOptionsTypePropertyDto interface.
 */
export function instanceOfIInvestmentOptionsTypePropertyDto(value: object): value is IInvestmentOptionsTypePropertyDto {
    return true;
}

export function IInvestmentOptionsTypePropertyDtoFromJSON(json: any): IInvestmentOptionsTypePropertyDto {
    return IInvestmentOptionsTypePropertyDtoFromJSONTyped(json, false);
}

export function IInvestmentOptionsTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentOptionsTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investment_options_types': json['investment_options_types'] == null ? undefined : new Set(json['investment_options_types']),
        'investment_options_type_state': json['investment_options_type_state'] == null ? undefined : json['investment_options_type_state'],
    };
}

export function IInvestmentOptionsTypePropertyDtoToJSON(json: any): IInvestmentOptionsTypePropertyDto {
    return IInvestmentOptionsTypePropertyDtoToJSONTyped(json, false);
}

export function IInvestmentOptionsTypePropertyDtoToJSONTyped(value?: IInvestmentOptionsTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investment_options_types': value['investment_options_types'] == null ? undefined : Array.from(value['investment_options_types'] as Set<any>),
        'investment_options_type_state': value['investment_options_type_state'],
    };
}

